import React from 'react';
import { Quote } from 'lucide-react';
export function ReviewsSection() {
  const reviews = [{
    text: "Generous portions and incredibly friendly staff. The lamb shank was the best I've had in Dublin!",
    author: 'Sarah M.',
    location: 'Visitor'
  }, {
    text: 'Amazing fish & chips and the Irish stew was absolutely delicious. A must-visit in Temple Bar.',
    author: 'James K.',
    location: 'Local Guide'
  }, {
    text: 'Such a welcoming atmosphere. We felt right at home. The beef & Guinness stew is unforgettable.',
    author: 'Maria L.',
    location: 'Visitor'
  }];
  return <section id="reviews" className="py-20 md:py-24 bg-background border-y border-border/30" data-id="element-255">
      <div className="container mx-auto px-4" data-id="element-256">
        <div className="text-center mb-16" data-id="element-257">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-foreground mb-4" data-id="element-258">
            What Our Guests Say
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full opacity-80" data-id="element-259"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-260">
          {reviews.map((review, index) => <div key={index} className="bg-card p-8 rounded-lg border border-border relative flex flex-col hover:border-primary/50 transition-colors" data-id="element-261">
              <div className="absolute -top-4 left-8 bg-background p-2 border border-border rounded-full text-primary" data-id="element-262">
                <Quote className="w-6 h-6 fill-primary" data-id="element-263" />
              </div>

              <div className="mt-4 flex-grow" data-id="element-264">
                <p className="text-lg text-muted-foreground italic leading-relaxed" data-id="element-265">
                  "{review.text}"
                </p>
              </div>

              <div className="mt-6 pt-6 border-t border-border/50" data-id="element-266">
                <p className="font-serif font-bold text-foreground text-lg" data-id="element-267">
                  {review.author}
                </p>
                <p className="text-sm text-primary/80 uppercase tracking-wider font-medium" data-id="element-268">
                  {review.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}